﻿export class WorkTrayViewInfo {
    id: string;
    name: string;
    isSystem: boolean;
}